import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_comp_entity_purchase_credit_terms_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_credit_terms_guid: fromDatatype.GuidDataFieldInterface;
  credit_terms_code: fromDatatype.VarcharDatatypeInterface;
  credit_terms_name: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  comp_entity_link_guid: fromDatatype.GuidDataFieldInterface;
  credit_terms_set_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_day: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_day: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_mst_comp_entity_purchase_credit_terms_RowCLass
  implements bl_fi_mst_comp_entity_purchase_credit_terms_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  entity_credit_terms_guid: fromDatatype.GuidDataFieldInterface;
  credit_terms_code: fromDatatype.VarcharDatatypeInterface;
  credit_terms_name: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  comp_entity_link_guid: fromDatatype.GuidDataFieldInterface;
  credit_terms_set_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_day: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_day: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}
